import Vue from 'vue';
import Vuex from 'vuex';
import ipify from 'ipify2';

import login from './login';
import ticket from './ticket';
import alerts from './alerts';
import box from './box';
import appointment from './appointment';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    ipDevice: null,
  },
  getters: {
    ipDevice: (state) => state.ipDevice,
  },
  mutations: {
    SET_IP(state, ipDevice) {
      state.ipDevice = ipDevice;
    },
  },
  actions: {
    async initApplication({ commit }) {
      const responseIP = await ipify.ipv4();
      commit('SET_IP', responseIP || 'Error al obtener IP');
    },
  },
  modules: {
    login,
    ticket,
    alerts,
    box,
    appointment,
  },
});
